import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const useMockData = false;

const getSearchQuery = (params) => (
  `${(params || useMockData) ? '?' : ''}${useMockData ? 'mock=1&' : ''}${params ? `${new URLSearchParams(params).toString()}` : ''}`
);

const getTicketSearchPath = (params) => (
  `${(params.json_search) ? params.json_search : '/api/ticket-search'}`
);

const getTicketAvailabilityPath = (params) => (
  `${(params.json_availability) ? params.json_availability : '/api/ticket-availability'}`
);

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    ticketAvailability: builder.query({
      query: (params) => ({
        url: `${getTicketAvailabilityPath(params)}${params.json_availability ? '' : getSearchQuery(params)}`,
      }),
    }),
    ticketSearch: builder.query({
      query: (params) => ({
        url: `${getTicketSearchPath(params)}${params.json_search ? '' : getSearchQuery(params)}`,
      }),
    }),
  }),
});

export const {
  useTicketAvailabilityQuery,
  useTicketSearchQuery,
} = apiSlice;
